@if (title) {
<strong mat-dialog-title class="popup_title dialogText">{{ title }}</strong>
}

<div mat-dialog-content class="dialogText">
  @if (!isHtmlContent) {
  <p>{{ message }}</p>
  }
  @if (isHtmlContent) {
  <div class="popup_htmlContent" [innerHTML]="message"></div>
  }
</div>

<div mat-dialog-actions>
  <button name="Ok" mat-raised-button color="primary" (click)="onConfirm()">{{ confirmButtonText }}</button>
  @if (showCancelButton()) {
  <button name="Cancel" mat-stroked-button (click)="onCancel()" [disabled]="false">Cancel</button>
  }
</div>
